/* eslint-disable no-useless-computed-key */
/* eslint-disable react/jsx-curly-newline */
import React, { useEffect, useLayoutEffect, useState } from 'react';
import { Col, Row, Input, Label, Button } from 'reactstrap';
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux';
import utils from '../../../../../lib/utils';
import useEpikBoxPri from './useEpikBoxPri';
import { setPriFailoversList, getPriStatus, updateEpikBox, updateSipPri } from '../../../../../actions/EpikBoxes';
import Toggle from '../../../../Toggle';
import ConfirmationModal from '../../../../ConfirmationModal';
import MultiSelectPriDropdown from '../../../../MultiSelectPriDropdown';
import AddSecurityCodeModal from '../../../../AddSecurityCodeModal';
import { ReactComponent as PriStatus } from '../../../../../Res/svg/PRI_Status_Check.svg'
import TooltipCustom from '../../TooltipCustom';
import CustomModal from '../../../../CustomModal';
import logoLoading from '../../../../../Res/logo-loading.gif';
import addBoxAction from '../../../../../lib/api/addBoxAction';
import addNote from '../../../../../lib/api/addNote';

export default function EpikBoxPri({ priSipStatus, setDcUpdatePopup }) {
  const [flag, setFlag] = useState(false);
  const box = useSelector(state => state.AppState.boxDetails.box);
  const priSettings = useSelector(state => state.AppState.priSipData?.priSettingData);
  const loggedInUser = useSelector(state => state.AppState.user);
  const companyPriBoxes = useSelector(state => state.UIState.companies.companyPriBoxes);

  const [numberOfChannel] = useState(24);
  const [dchannel, setDchannel] = useState('');
  const [bchannel, setBchannel] = useState('');
  const [dchannelArray, setDchannelArray] = useState([]);
  const [channelBValidValues, setChannelBValidValues] = useState([]);
  const [channelBSubset, setChannelBSubset] = useState([]);
  const [channelRange, setChannelRange] = useState('');
  const [channelRangeExpanded, setChannelRangeExpanded] = useState([]);
  const [echoCancellation, setEchoCancellation] = useState(false);
  const [defaultPri, setDefaultPri] = useState(false);
  const [warningModal, setWarningModal] = useState(false);
  const [priCompaniesList, setPriCompaniesList] = useState([]);
  const [priFailovers, setPriFailovers] = useState([]);
  const [preSelectedPriList, setPreSelectedPriList] = useState([]);
  const [priToggle, setPriToggle] = useState(false);
  const [securityModal, setSecurityModal] = useState(false);
  const [sortedPriList, setSortedPriList] = useState([]);


  const defaultEnabledStates = {
    dchannelInput: false,
    bchannel: false,
    channelRange: false,
    numberOfChannel: false,
  };
  const [isEnableInput, setIsEnableInput] = useState(defaultEnabledStates);
  const [priStatusModalOpen, setPriStatusModalOpen] = useState(false);
  const [priLoading, setPriLoading] = useState(false);
  const [priStatus, setPriStatus] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);

  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;

  useEffect(() => {
    if (companyPriBoxes?.length > 0) {
      setPriCompaniesList(companyPriBoxes);
    }
  }, [companyPriBoxes]);

  const handleBChannelChange = value => {
    const regex = /^[-,0-9]+$/;
    if (value.match(regex) || !value) {
      const expandedArray = utils.validateChannelInput(value);
      setChannelBValidValues(expandedArray);
      const dChannel = dchannel ? [+dchannel] : [];
      setDchannelArray(dChannel);
      if (Math.max(...expandedArray) <= +numberOfChannel) {
        if (utils.compareArrays(expandedArray, dChannel) && value) {
          toast.error(`${dchannel} is already added in D Channel`);
        } else if (expandedArray?.length + dChannel?.length > +numberOfChannel) {
          toast.error(`Number of channels exceded from Range of Channels`);
        } else {
          setBchannel(value);
          if (value) {
            setIsEnableInput({
              ...defaultEnabledStates,
              bchannel: true,
              channelRange: true,
            });
          }
        }
      } else {
        toast.error(`Channel value should be less than Number of Channels`);
      }
    }
  };

  const handleDchannel = value => {
    const regex = /^[0-9]+$/;
    if (value.match(regex) || !value) {
      const expandedArray = utils.validateChannelInput(bchannel);
      const dChannel = value ? [+value] : [];
      if (utils.compareArrays(expandedArray, dChannel)) {
        toast.error(`${value} is already added in D Channel`);
      } else if (value <= +numberOfChannel) {
        setDchannel(value);
        if (value) {
          setIsEnableInput({
            ...defaultEnabledStates,
            bchannel: true,
            dchannelInput: true,
          });
        }
      } else {
        toast.error(`Number of Channels should be in the range of 1-24`);
      }
    }
  };

  const handleChannelRange = value => {
    const regex = /^[-,0-9]+$/;
    if (value.match(regex) || !value) {
      const expandedArray = utils.validateChannelInput(value);
      setChannelRangeExpanded(expandedArray);
      const filterArry = channelBValidValues.filter(r => expandedArray.includes(r));
      setChannelBSubset(JSON.stringify(filterArry) === JSON.stringify(expandedArray));
      setChannelRange(value);
    }
  };

  const startOver = () => {
    setIsEnableInput({
      ...defaultEnabledStates,
      dchannelInput: true,
    });
    setDchannel('');
    setBchannel('');
    setDefaultPri(true);
  };

  const { produceState, dropDownStates, handleDropDownStates } = useEpikBoxPri(
    numberOfChannel,
    dchannel,
    bchannel,
    channelRange,
    echoCancellation,
    defaultPri,
    priFailovers,
    sortedPriList
  );

  const onSubmit = async e => {
    const ispri = true;
    e.preventDefault();
    setSaveLoading(true);
    
    try {
      const newState = produceState();
      const priSettingsUpdated = { ...priSettings, ...newState };
      const updatedFeature = { ...box?.features, pri: priSipStatus?.pri, sip: priSipStatus?.sip };
      let priNumberSettings = {
        ...priSettingsUpdated,
        numberSettings: priSettings?.numberSettings || [],
      };

      if (priToggle) {
        if (priNumberSettings.priFailovers?.length <= 0) {
          toast.error('Select atleast One failover backup');
          setSaveLoading(false);
          return
        }
      } else {
        priNumberSettings = { ...priNumberSettings, priFailovers: [] }
      }
      
      let sipPriResponse;

      if (flag) {
        if (dchannelArray?.length + channelBValidValues?.length === +numberOfChannel) {
          if (channelBSubset) {
            if (bchannel?.length) {
              setIsEnableInput({
                ...defaultEnabledStates,
              });
              await dispatch(
                updateEpikBox(token, {
                  ...box,
                  features: updatedFeature,
                }),
              );
              
              sipPriResponse = await dispatch(updateSipPri(token, box?._id, ispri, priNumberSettings));
            } else {
              toast.error(`B channel is empty`);
            }
          } else {
            toast.error(
              `${channelRangeExpanded?.toString()} is not subset of ${channelBValidValues?.toString()}`,
            );
          }
        } else {
          toast.error(`D channel and B channel is not equal to Number of Channels`);
        }
      }
      if (!flag) {
        await dispatch(
          updateEpikBox(token, {
            ...box,
            features: updatedFeature,
          }),
        );
        sipPriResponse = await dispatch(updateSipPri(token, box?._id, ispri, priNumberSettings));
      }

      if (sipPriResponse) {
        addBoxAction({ boxID: box?._id, activity: 'updated PRI details' });
        addNote({ boxID: box?._id, note: "PRI details updated"});
      }

      setWarningModal(true);
      setIsEnableInput(defaultEnabledStates);
      setPreSelectedPriList([])
    } catch (error) {
      console.error('Error saving PRI details:', error);
      toast.error('Failed to save PRI details');
    } finally {
      setSaveLoading(false);
    }
  };

  const setPreSelectedList = (list) => {
    console.log({ list, companyPriBoxes })
    const preSelectedList = [];
    list?.forEach(item => {
      const found = companyPriBoxes?.find(box => box?.serialNumber === item);
      if (found) {
        preSelectedList.push(found);
      }
    });
    console.log('setPreSelectedList preSelectedList :::', preSelectedList);
    setPreSelectedPriList(preSelectedList);
  }

  useEffect(() => {
    if (priSettings && Object?.entries(priSettings).length) {
      setDchannel(priSettings?.dChannel || '');
      setBchannel(priSettings?.bChannels || '');
      setChannelRange(priSettings?.echoChannels || '');
      setEchoCancellation(priSettings?.echoCancellation || false);
      setPriFailovers(priSettings?.priFailovers || []);
      if (priSettings?.priFailovers?.length > 0) {
        setPreSelectedList(priSettings?.priFailovers);
        setPriToggle(true)
      }
    }
  }, [priSettings]);

  //remove this code after PRI failover backup testing
  useEffect(() => {
    // if (Object?.entries(box?.priSettings).length) {
    //   setDchannel(box?.priSettings?.dChannel || '');
    //   setBchannel(box?.priSettings?.bChannels || '');
    //   setChannelRange(box?.priSettings?.echoChannels || '');
    //   setEchoCancellation(box?.priSettings?.echoCancellation || false);
    //   setPriFailovers(box?.priSettings?.priFailovers || []);
    //   if (box?.priSettings?.priFailovers?.length > 0) {
    //     setPreSelectedList(box?.priSettings?.priFailovers);
    //   }
    // }
    // console.log('priSettings', box.priSettings)
  }, [box]);


  const onMouseOver = () => {
    setDefaultPri(false);
  };

  const onPriChange = async (list) => {
    await dispatch(setPriFailoversList(list));
    const listNumbers = list?.reduce((acc, curr) => {
      acc.push(curr.serialNumber);
      return acc;
    }, []);

    setPriFailovers(listNumbers);
  }

  const onTogglePri = (e) => {
    setPriToggle(!e);
    // if (!e) {
    //   setSecurityModal(true);
    // } else {
    //   setPriToggle(false);
    // }
  }

  const onSecurityConfirm = () => {
    setPriToggle(!priToggle);
    setSecurityModal(false);
  }

  const sortedDataList = (data) => {
    setSortedPriList(data);
  }

  const onPriStatusCheck = async () => {
    setPriStatusModalOpen(true);
    setPriLoading(true);
    const result = await dispatch(getPriStatus(token, box?.vpnAddress));
    if (result && result?.response[0]) {
      setPriStatus(result?.response[0] === 'UP' ? 'Passed' : 'Failed');
    } else {
      setPriStatus('N/A');
    }
    setPriLoading(false);
    console.log(result);
  }

  return (
    <div className="priContainer">
      <div className="d-flex justify-content-between align-items-start mb-4">
        <p className="heading">PRI Settings</p>
        <div className='d-flex align-items-center'>
          <PriStatus
            onClick={onPriStatusCheck}
            id='priSipStatus' width={30} height={30} className='mr-2 cursor-pointer' />
          <TooltipCustom tipId="priSipStatus" displayData='PRI Status Check' placement="top" />
        </div>

      </div>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              Number of Channels
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input required value={numberOfChannel} disabled type="text" name="numberOfChannel" />
          </Col>
        </Row>
      </div>
      <Row style={{ paddingTop: '5px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">T1 Framing</Label>
        </Col>
        <Col sm={6} md={5}>
          <Input
            type="select"
            value={dropDownStates.framing}
            onChange={e => handleDropDownStates('framing', e.currentTarget.value)}
          >
            <option key="d4" value="d4">
              d4
            </option>
            <option key="esf" value="esf">
              esf
            </option>
            <option key="cas" value="cas">
              cas
            </option>
          </Input>
        </Col>
      </Row>
      <Row style={{ paddingTop: '5px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">Line Code</Label>
        </Col>
        <Col sm={6} md={5}>
          <Input
            type="select"
            value={dropDownStates.lineCode}
            onChange={e => handleDropDownStates('lineCode', e.currentTarget.value)}
          >
            <option key="b8zs" value="b8zs ">
              b8zs
            </option>
            <option key="ami" value="ami">
              ami
            </option>
          </Input>
        </Col>
      </Row>
      <Row style={{ paddingTop: '5px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">Timing Source</Label>
        </Col>
        <Col sm={6} md={5}>
          <Input
            type="select"
            value={dropDownStates.timeAndSource}
            onChange={e => handleDropDownStates('timeAndSource', e.currentTarget.value)}
          >
            <option key="internal" value="internal">
              Internal
            </option>
            <option key="external" value="external">
              External
            </option>
          </Input>
        </Col>
      </Row>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              D Channel
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input
              onChange={e => handleDchannel(e.target.value)}
              required
              onFocus={() => {
                if (numberOfChannel) {
                  setIsEnableInput({ ...isEnableInput, numberOfChannel: false });
                }
              }}
              value={dchannel}
              disabled={!isEnableInput?.dchannelInput}
              type="text"
              name="name"
            />
          </Col>
        </Row>
      </div>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              B Channel
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input
              onChange={e => handleBChannelChange(e.target.value)}
              required
              onFocus={() => {
                if (dchannel) {
                  setIsEnableInput({ ...isEnableInput, dchannelInput: false });
                }
              }}
              disabled={!isEnableInput?.bchannel}
              value={bchannel}
              type="text"
              name="name"
            />
          </Col>
        </Row>
      </div>
      <Row style={{ paddingTop: '5px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">Switch Type</Label>
        </Col>
        <Col sm={6} md={5}>
          <Input
            type="select"
            value={dropDownStates.switchType}
            onChange={e => handleDropDownStates('switchType', e.currentTarget.value)}
          >
            <option key="national" value="national">
              national
            </option>
            <option key="ni2" value="ni2">
              ni2
            </option>
            <option key="4ess" value="4ess">
              4ess
            </option>
            <option key="5ess" value="5ess">
              5ess
            </option>
            <option key="qsig" value="qsig">
              qsig
            </option>
            <option key="euroisdn" value="euroisdn">
              euroisdn
            </option>
            <option key="ntt" value="ntt">
              ntt
            </option>
          </Input>
        </Col>
      </Row>
      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              Echo Cancellation
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Toggle
              value={echoCancellation}
              onToggle={e => {
                setEchoCancellation(!e);
              }}
            />
          </Col>
        </Row>
      </div>

      <div className="sip-section ">
        <Row className="sip-input ">
          <Col sm={6} md={4}>
            <Label for="name" className="sip-input-label">
              Channel Range
            </Label>
          </Col>
          <Col sm={6} md={5}>
            <Input
              onChange={e => handleChannelRange(e.target.value)}
              required
              onFocus={() => {
                if (bchannel) {
                  setIsEnableInput({ ...isEnableInput, bChannels: false });
                }
              }}
              value={channelRange}
              type="text"
              name="name"
              disabled={!isEnableInput?.channelRange || !echoCancellation}
            />
          </Col>
        </Row>
      </div>
      <Row style={{ paddingTop: '5px', marginBottom: '15px' }}>
        <Col sm={6} md={4}>
          <Label className="sip-input-label">Echo Cancelation Type</Label>
        </Col>
        <Col sm={6} md={5}>
          <Input
            required
            value={dropDownStates.echoCancellationType}
            type="text"
            name="echoCancelationType"
            disabled
          />
        </Col>
      </Row>
      <Row style={{ paddingTop: '5px', marginBottom: '15px' }}>
        <Col sm={6} md={4}>
          <Label className="pri-input-label bold">PRI Failover</Label>
        </Col>
        <Col sm={6} md={5}>
          <Toggle
            value={priToggle}
            onToggle={(e) => onTogglePri(e)}
          />
        </Col>
      </Row>
      {
        priToggle ?
          <Row style={{ paddingTop: '5px', marginBottom: '15px' }}>
            <Col sm={6} md={4}>
              <Label className="sip-input-label underline">Select Backup PRI</Label>
            </Col>
            <Col sm={6} md={5}>
              <MultiSelectPriDropdown
                MultiSelect
                nameTag="serialNumber"
                filterTag="serialNumber"
                className="testing-filter"
                placeholder={
                  !(priCompaniesList?.length > 0)
                    ? 'No Boxes Found'
                    : 'Select Box Serial Number'
                }
                dropdownList={priCompaniesList}
                showFirstListElement
                onChange={onPriChange}
                initialList={preSelectedPriList}
                sortedData={sortedDataList}
              />
            </Col>
          </Row>
          : null
      }

      <Row
        justify="space-between">
        <Button
          onMouseDown={onMouseOver}
          color="primary"
          title="This will erase all channel ranges"
          onClick={startOver}
        >
          Reset Settings
        </Button>
        <Col className="pri-save-btn">
          <Button  
            color="primary"  
            disabled={saveLoading}
            onClick={ (e) => {
              const divElement = document.getElementById('test-time-remaining');
              const isHidden = divElement.getAttribute('hidden') !== null;
              if (isHidden) {
                setDcUpdatePopup({ show: true });
              } else {
                onSubmit(e);
              }
            }}
          >
            {saveLoading ? (
              <>
                <img src={logoLoading} className="loading-logo-sm mr-2" alt="loading" style={{ width: '16px', height: '16px' }} />
                Saving...
              </>
            ) : (
              'Save PRI Detail'
            )}
          </Button>
        </Col>
      </Row>
      <CustomModal
        header="PRI Status Check"
        isOpen={priStatusModalOpen}
        onCancel={() => setPriStatusModalOpen(false)}
        close
        medium
      >
        <div className='align-items-center justify-content-center d-flex'>
          {
            priLoading ?
              <img src={logoLoading} className="loading-logo-sm" alt="loading" />
              :
              <label className='header-pri-text mt-4 mb-4'>
                PRI Status :
                <span className={`ml-1 ${priStatus === 'UP' ? "text-success" : "text-danger"} bold`}>{priStatus}{!priSettings?.isSynced && " / database not synced"}</span>
              </label>
          }
        </div>
      </CustomModal>
      <ConfirmationModal
        bodyText="Please reboot this device for changes to take effect."
        isOpen={warningModal}
        onCancel={() => setWarningModal(false)}
        ignoreConfirmButton
        close
      />
      <AddSecurityCodeModal
        isOpen={securityModal}
        onCancel={() => setSecurityModal(false)}
        onConfirm={onSecurityConfirm}
        featureName='priFailover'
      />
    </div>
  );
}
